import { render, staticRenderFns } from "./TerminalConsulta.vue?vue&type=template&id=0ea1fb1a&scoped=true"
import script from "./TerminalConsulta.vue?vue&type=script&lang=js"
export * from "./TerminalConsulta.vue?vue&type=script&lang=js"
import style0 from "./TerminalConsulta.vue?vue&type=style&index=0&id=0ea1fb1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea1fb1a",
  null
  
)

export default component.exports